import { call, put, takeEvery } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import * as api from 'api'
import {
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  LOG_IN,
  LOG_IN_SUCCESS,
  LOG_IN_ERROR,
  LOG_OUT,
  LOG_OUT_SUCCESS,
  LOG_OUT_ERROR,
  CHECK_AUTH_STATUS,
  CHECK_AUTH_STATUS_SUCCESS,
  CHECK_AUTH_STATUS_ERROR,
} from 'actionTypes'

function* register({ name, email, password }) {
  try {
    const user = yield call(api.register, name, email, password)
    yield put({ type: REGISTER_SUCCESS, user })
  } catch ({ message }) {
    yield put({ type: REGISTER_ERROR, message })
  }
}

function* logIn({ email, password }) {
  try {
    const user = yield call(api.logIn, email, password)
    yield put({ type: LOG_IN_SUCCESS, user })
  } catch ({ message }) {
    yield put({ type: LOG_IN_ERROR, message })
  }
}

function* logOut() {
  try {
    yield call(api.logOut)
    yield put({ type: LOG_OUT_SUCCESS })
  } catch ({ message }) {
    yield put({ type: LOG_OUT_ERROR, message })
  }
}

function* checkAuthStatus() {
  try {
    const user = yield call(api.checkAuthStatus)
    yield put({ type: CHECK_AUTH_STATUS_SUCCESS, user })
  } catch ({ message }) {
    yield put({ type: CHECK_AUTH_STATUS_ERROR, message })
  }
}

function* goToRoot() {
  yield put(push('/'))
}

function* saga() {
  yield takeEvery(REGISTER, register)
  yield takeEvery(LOG_IN, logIn)
  yield takeEvery(LOG_OUT, logOut)
  yield takeEvery(CHECK_AUTH_STATUS, checkAuthStatus)
  yield takeEvery(LOG_OUT_SUCCESS, goToRoot)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/auth.js